import React from 'react';
import { Heart, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-2xl font-bold bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">
                Zosia
              </span>
              <span className="text-sm text-slate-400">Mała Nauczycielka</span>
            </div>
            <p className="text-slate-400 leading-relaxed mb-4">
              Pierwszy polski robot edukacyjny do nauki kodowania, języków obcych i kompetencji STEAM.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=100083413837091"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/fundacja_eduko/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/fundacja-edukacja-dla-rozwoju-eduko/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCKhINDLrXHopSLd-5Ng7KHg"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Przydatne linki</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://sklep.eduko.pl/pages/o-nas" className="text-slate-400 hover:text-orange-400 transition-colors">
                  O firmie Eduko
                </a>
              </li>
              <li>
                <a href="https://sklep.eduko.pl/pages/kontakt" className="text-slate-400 hover:text-orange-400 transition-colors">
                  Kontakt
                </a>
              </li>
              <li>
                <a href="https://sklep.eduko.pl/pages/dostawa-i-formy-platnosci" className="text-slate-400 hover:text-orange-400 transition-colors">
                  Dostawa i płatności
                </a>
              </li>
              <li>
                <a href="https://sklep.eduko.pl/policies/refund-policy" className="text-slate-400 hover:text-orange-400 transition-colors">
                  Zwroty i reklamacje
                </a>
              </li>
              <li>
                <a href="https://sklep.eduko.pl/policies/privacy-policy" className="text-slate-400 hover:text-orange-400 transition-colors">
                  Polityka prywatności
                </a>
              </li>
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3 text-slate-400">
              <li>
                <a href="tel:+48601295295" className="hover:text-orange-400 transition-colors">
                  📞 +48 601 295 295
                </a>
              </li>
              <li>
                <a href="mailto:biuro@eduko.pl" className="hover:text-orange-400 transition-colors">
                  ✉️ biuro@eduko.pl
                </a>
              </li>
              <li className="pt-2">
                <div className="text-sm">
                  Eduko.pl<br />
                  Fundacja Edukacja dla Rozwoju
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-slate-400 text-sm">
              © {currentYear} Eduko.pl. Wszystkie prawa zastrzeżone.
            </div>
            <div className="flex items-center space-x-1 text-slate-400 text-sm">
              <span>Stworzone z</span>
              <Heart className="w-4 h-4 text-orange-500 fill-orange-500" />
              <span>dla polskiej edukacji</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
